// Plan Your Bermuda Stay — experience data. Update this ONE file as recommendations change.

export const TRAVELLERS = ["Couple", "Family", "Friends", "Solo"];
export const DURATIONS = ["3 days", "5 days", "7+ days"];
export const INTERESTS = ["Beaches", "Food", "History", "Nightlife", "Adventure", "Shopping", "Relaxation"];

export const PARISHES = ["St. George's", "Hamilton Parish", "Smith's", "Devonshire", "Pembroke", "Paget", "Warwick", "Southampton", "Sandys"];

// Near-parish highlights: "within roughly 15 minutes of you"
export const PARISH_NEARBY = {
  "St. George's": ["Tobacco Bay's turquoise rocks", "The lanes of the Old Town, a UNESCO World Heritage site", "St. Peter's Church"],
  "Hamilton Parish": ["Crystal Caves' underground pools", "Shelly Bay's shallow, calm beach", "The Railway Trail through the parish"],
  "Smith's": ["Spittal Pond's coastal nature reserve", "John Smith's Bay for easy snorkelling", "The Railway Trail east"],
  "Devonshire": ["The Bermuda Arboretum's green calm", "Devonshire Bay's local fishing beach", "Palm Grove Gardens"],
  "Pembroke": ["Hamilton's Front Street, harbour and restaurants", "The Bermuda National Gallery", "Fort Hamilton's views and gardens"],
  "Paget": ["Elbow Beach's long pink-sand curve", "The Botanical Gardens and Camden House", "Front Street, one ferry stop away"],
  "Warwick": ["Warwick Long Bay — arguably Bermuda's most beautiful beach", "Jobson's Cove, a sheltered natural pool", "The South Shore coastal trail"],
  "Southampton": ["Horseshoe Bay, the island's famous pink sand", "The Lighthouse at Gibbs Hill for 360° views", "Church Bay's snorkelling reef"],
  "Sandys": ["Royal Naval Dockyard's museums, shops and dolphins", "Somerset Bridge — the world's smallest drawbridge", "Snorkel Park and the West End beaches"],
};

export const EXPERIENCES = {
  Beaches: [
    ["Horseshoe Bay morning", "Arrive before 10am for the famous pink sand at its quietest.", "Beach"],
    ["Warwick Long Bay to Jobson's Cove walk", "A gorgeous beach-to-cove wander along the South Shore.", "Beach"],
    ["Tobacco Bay afternoon", "Calm, shallow, turquoise — with beach bar energy.", "Beach"],
  ],
  Food: [
    ["The fish sandwich pilgrimage", "Bermuda's signature — raisin bread, fried fish, tartar, coleslaw. Debate the best over lunch.", "Food"],
    ["Front Street dinner", "Hamilton's harbour-front dining at golden hour.", "Food"],
    ["Sunday brunch, Bermuda style", "Codfish and potatoes if you're brave; something sweeter if you're wise.", "Food"],
  ],
  History: [
    ["St. George's Old Town", "Four centuries of lanes, forts and stories — allow a half day.", "History"],
    ["Royal Naval Dockyard", "Maritime history, the National Museum and craft shops in one stop.", "History"],
    ["A moongate walk", "Find and walk through one of Bermuda's iconic moon gates — legend says it brings luck.", "History"],
  ],
  Nightlife: [
    ["Hamilton after dark", "Harbour-side cocktails and Front Street's evening hum.", "Nightlife"],
    ["A sunset sail", "Rum swizzles on the water as the sky does its thing.", "Nightlife"],
    ["Beach bonfire evening", "Ask your co-host about the island's best evening beach spots.", "Nightlife"],
  ],
  Adventure: [
    ["Snorkel a wreck or reef", "Bermuda is the shipwreck capital of the Atlantic.", "Adventure"],
    ["Cliff jumping at Clarence Cove", "For the brave — calm, deep and exhilarating.", "Adventure"],
    ["Kayak the sheltered bays", "Glassy morning water along the South Shore.", "Adventure"],
  ],
  Shopping: [
    ["Front Street boutiques", "Island brands, linen, jewellery and Bermudian art.", "Shopping"],
    ["Dockyard craft market", "Local makers — rum cakes, cedar work, sea-glass jewellery.", "Shopping"],
    ["St. George's independents", "Small shops in 400-year-old buildings.", "Shopping"],
  ],
  Relaxation: [
    ["A nothing-morning", "Coffee on the veranda. That's the whole plan. Bermuda rewards it.", "Relaxation"],
    ["Spa afternoon", "Book a treatment; let the island slow you down properly.", "Relaxation"],
    ["Sunset from your own terrace", "The best seat in Bermuda is often the one at your rental.", "Relaxation"],
  ],
};

const DAY_TEMPLATES = {
  "3 days": ["Arrival & your neighbourhood", "Signature Bermuda day", "Slow morning & departure"],
  "5 days": ["Arrival & your neighbourhood", "Beach day", "History & culture day", "Adventure or food day", "Slow morning & departure"],
  "7+ days": ["Arrival & your neighbourhood", "Beach day", "History & culture day", "West End day", "Adventure day", "East End day", "Slow morning & departure"],
};
export { DAY_TEMPLATES };
